import { Injectable } from '@angular/core';
import {
  AlertAdvisoriesItem,
  ContentAlertAdvisory
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  ApplicationAdvisoriesListAem,
  checkStringValueNull,
  HeaderFooterMachCore
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { MessageBannerOptions } from '@com-delta-omnichannel/mach-core-js';
import { parseAemContent } from '../../utils/alert-advisories/aem-content-parser.util';
@Injectable({
  providedIn: 'root'
})
export class AlertAdvisoriesAdaptersService {
  setDefaultDisplay = false;

  getContent(aem: HeaderFooterMachCore): ContentAlertAdvisory {
    this.setDefaultDisplayData(aem);
    return {
      messageBanner: this.initMessageBanner(aem)
    };
  }

  getAdvisoryList(aem: HeaderFooterMachCore): AlertAdvisoriesItem {
    const list = aem.applicationadvisories.ApplicationAdvisoriesList;
    if (!list) {
      return { title: '', apptype: '', advisoryKey: '', pageUrl: '' };
    }
    return this.mapAdvisory(list);
  }

  private mapAdvisory(
    advisory: ApplicationAdvisoriesListAem[]
  ): ApplicationAdvisoriesListAem {
    return {
      title: parseAemContent(advisory[0].title).title,
      apptype: checkStringValueNull(advisory[0].apptype),
      advisoryKey: checkStringValueNull(advisory[0].advisoryKey),
      pageUrl: checkStringValueNull(advisory[0].pageUrl)
    };
  }

  setDefaultDisplayData(data: HeaderFooterMachCore): void {
    const { defaultDisplay } = data.applicationadvisories;
    this.setDefaultDisplay =
      defaultDisplay != null &&
      defaultDisplay !== '' &&
      defaultDisplay.toLowerCase() !== 'false';
  }

  initMessageBanner(aem: HeaderFooterMachCore): MessageBannerOptions {
    return {
      id: 'alert-sticky-message-banner',
      type: 'warning',
      isSticky: true,
      hasBar: true,
      iconSize: 'small',
      content: {
        header: {
          title: this.getTitle(aem),
          hasCloseButton: aem.applicationadvisories.hideCloseButton === 'false'
        },
        description: this.getDescription(aem)
      }
    };
  }

  getTitle(aem: HeaderFooterMachCore): string {
    const alertAdvisoriesLabel = checkStringValueNull(
      aem.applicationadvisories.alertAdvisoriesLabel
    );

    return alertAdvisoriesLabel && !this.setDefaultDisplay
      ? alertAdvisoriesLabel
      : this.getAdvisoryList(aem).title;
  }

  getDescription(aem: HeaderFooterMachCore): string {
    const alertAdvisoriesLabel = checkStringValueNull(
      aem.applicationadvisories.alertAdvisoriesLabel
    );

    if (alertAdvisoriesLabel) {
      return (
        aem.applicationadvisories.ApplicationAdvisoriesList?.[0]?.title || ''
      );
    }

    const parsedContent = parseAemContent(
      aem.applicationadvisories.ApplicationAdvisoriesList?.[0]?.title || ''
    );
    return parsedContent.description;
  }
}
